// extracted by mini-css-extract-plugin
export default {"pay":"pay_pay__FQLsp","top":"pay_top__Kcdvy","paybill":"pay_paybill__aKUoD","bus":"pay_bus__ZTZ67","name":"pay_name__BNxxU"};